import React from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../AppContext';

const AppTutorial = ({ onTutorialComplete }) => {
    const { t } = useTranslation();
    const { appFunctions } = useAppContext();

    const steps = [
        {
            target: '.feed-container', // You'll need to add this class to your main feed container in App.js
            content: t('tutorial.step1'),
            disableBeacon: true,
        },
        {
            target: '#create-whisper-button', // You'll need to add this ID to your create post button
            content: t('tutorial.step2'),
        },
        {
            target: 'a[href="/nexus"]', // Targets the NavLink to the Nexus Hub
            content: t('tutorial.step3'),
        },
        {
            target: '#wallet-hub-button', // You'll need to add this ID to your wallet/echoes balance element
            content: t('tutorial.step4'),
        },
        {
            target: '#user-profile-button', // You'll need to add this ID to your profile link/button
            content: t('tutorial.step5'),
        }
    ];

    const handleJoyrideCallback = async (data) => {
        const { status } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            try {
                const markTutorialAsCompleted = httpsCallable(appFunctions, 'markTutorialAsCompleted');
                await markTutorialAsCompleted();
                onTutorialComplete(); // Notify App.js to update its state
            } catch (error) {
                console.error("Failed to mark tutorial as completed:", error);
                // Still hide the tutorial, but we'll try again next time
                onTutorialComplete();
            }
        }
    };

    const joyrideStyles = {
        options: {
            arrowColor: '#334155', // slate-700
            backgroundColor: '#1e293b', // slate-800
            primaryColor: '#38bdf8', // sky-400
            textColor: '#e2e8f0', // slate-200
            zIndex: 10000,
        },
        tooltip: {
            border: '1px solid #334155', // slate-700
            borderRadius: '1rem', // rounded-2xl
        },
        buttonNext: {
            borderRadius: '9999px', // rounded-full
            fontWeight: 'bold',
        },
        buttonBack: {
            borderRadius: '9999px', // rounded-full
        },
        buttonClose: {
            color: '#94a3b8', // slate-400
        },
    };

    return (
        <Joyride
            steps={steps}
            run={true}
            continuous={true}
            showProgress={true}
            showSkipButton={true}
            callback={handleJoyrideCallback}
            styles={joyrideStyles}
        />
    );
};

export default AppTutorial;
